import React, { useState } from "react";
import { Card, Spin, Icon } from "antd";
import { MerchantService } from "../../services";
import { alertify, printRupee } from "../../app_methods";
import { connect } from "react-redux";
import { updateCurrentUserAction } from "../../redux/actions";
import { Text2, Text3 } from "../../styles";
import { PermissionHoc } from "../HOC";
import _ from "lodash";
import WalletAccountStatementDrawer from "./wallet_account_statement_drawer";


const WalletSettings = (props) => {
    const [isFetching, setIsFetching] = useState(false);
    const [showAccountStatement, setShowAccountStatement] = useState(false);


	const fetchMerchantInfo = () => {
        setIsFetching(true);
		MerchantService.fetch().then((response) => {
			if (response.success) props.updateCurrentUser(response.data.merchant);
            setIsFetching(false);
		});
        alertify("Success!", "Balance updated successfully.", "success");
	};
 

    const AccountCards = ({title, wallet}) => {
        const renderAccountStatement = () =>{
                return (
                    <div className="d-flex align-items-center justify-content-center" onClick={() => {setShowAccountStatement(!showAccountStatement)}}>
                            <Icon className="mr-1" type="account-book" key="setting" style={{ fontSize: 12 }} /> Statement
                    </div> 
                )
            }
        
        const renderRetrieveBalanceBtn = () =>{
            return (
                <div className="d-flex align-items-center justify-content-center" onClick={() => {fetchMerchantInfo()}}>
                        <Icon className="mr-2" type="wallet" key="wallet" style={{ fontSize: 12 }} /> Balance
                </div> 
            )
        }


        const cardFooter = () => {
            return [renderAccountStatement(), renderRetrieveBalanceBtn()]
        } 
    
        return (
            <>
                <Text2 className=" mb-2 mt-2 d-block" strong>{title}</Text2>
                    <div className="d-flex flex-wrap">
                        <Card
                            className={`d-flex flex-column justify-content-between ${wallet.status!==`active` && `deactivated-payout-account-card`} rounded shadow-sm mb-4 mr-2`}
                            style={{ width: 300, paddingTop: "0.5rem" }}
                            title={false}
                            actions={cardFooter()}
                        >
                            <div className="pl-3 mb-2">
                                <>
                                    <Text3 className="d-block">{wallet.account_number}</Text3>
                                    <Text3 className="d-block" type="secondary">{wallet.ifsc}</Text3>
                                </>
                                <Text3 className="d-block" type="secondary">{printRupee(wallet.balance_amount, 3)}</Text3>
                            </div>
                        </Card>
                </div>
                <WalletAccountStatementDrawer
                    visible={showAccountStatement}
                    toggleWalletAccountStatementDrawer={()=>setShowAccountStatement(!showAccountStatement)}
                />
            </>)
    };


	return (
            <AccountCards wallet={props.current_user.wallet} title="Easebuzz Credits" />            
	);
};

const mapStateToProps = (state) => ({
	current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(WalletSettings,"VIRTUAL_ACCOUNTS_READ"));
